for (const el of document.querySelectorAll('.vp-block-news')) {
  const select = el.querySelector('select')
  const url = document
    .querySelector('link[rel="canonical"]')
    ?.getAttribute('href')

  select.addEventListener('input', (e) => {
    const cat = parseInt(select.value, 10) > 0 ? select.value : false
    document.location.href = cat ? `${url}?cat=${cat}` : `${url}`
  })
}

// scroll to news list if url contains /page/ or ?cat=
const page = document.location.pathname.includes('/page/')
const cat = !!new URL(document.location).searchParams.get('cat') || false
if (page || cat) {
  const top = document.querySelector('.vp-block-news').offsetTop
  const adminBar = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--admin-bar'),
    10
  )
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-height'
    ),
    10
  )

  window.scrollTo({
    top:
      document.querySelector('.vp-block-news').offsetTop -
      adminBar -
      headerHeight,
    left: 0,
    behavior: 'smooth',
  })
}
